import React from "react";
import blueHelp from "../../../../images/icon--blueHelp.svg";
import { sendEvent } from "../../../../helpers/analytics";

export const WhatHappensNextCTA = ({
  handleClick,
  happensNextCardRef
}) => {
  return (
    <div className="ch-display--flex ch-justify-content--center">
      <img src={blueHelp} alt=""/>
      <button
        className="ch-btn--link"
        onClick={() => {
          sendEvent("event", "interaction", {
            label: "What happens next"
          });
          handleClick(happensNextCardRef);
        }}
      >
        What happens next?
      </button>
    </div>
  );
};
